export enum AddTruckType {
  TRUCK_ADD_FLOW = "truckAddFlow",
  MATERIAL_VENDOR_FLOW = "materialVendorFlow",
}
